export const ADD_CLIENT="ADD_CLIENT";
export const CLIENT_DETAILS="CLIENT_DETAILS";
export const CLIENT_DATA="CLIENT_DATA";
export const ADD_NOTICE="ADD_NOTICE";
export const NOTICE_DETAILS="NOTICE_DETAILS";
export const NOTICE_DATA="NOTICE_DATA";
export const ADD_PROJECT_DATA="ADD_PROJECT_DATA";
export const ADD_CUSTOMER_DATA="ADD_CUSTOMER_DATA";
export const CUSTOMER_LIST= "CUSTOMER_LIST";
export const ADD_DESIGNATION_DATA= "ADD_DESIGNATION_DATA";
export const EMAIL_DATA= "EMAIL_DATA";
